import React from 'react'
import {
  Container
} from './styles'

export const StoreCloser = (props) => {
  const {
    business,
    closeModalCloserAlert,
    isBusinessListing
  } = props
  return (
    <Container>
      <h2>Special Occasion Notice</h2>
      <img src='https://res.cloudinary.com/acuity/image/upload/v1725342079/closestore_b49isy.png'></img>
      <p>This store is closed from {business?.storecloser?.startdate} to {business?.storecloser?.enddate} due to {business?.storecloser?.message}.</p>
      { isBusinessListing && (
      <button type='button' className='okbttn' onClick={() => closeModalCloserAlert()}>Ok</button>
      )}
    </Container>
  )
}
